import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../../../theme';
import { default as Tooltip } from '../../../../../../../BaseComponents/Tooltip';
import { useTranslation } from 'react-i18next';
import { CdnIcon } from '@shared/ui';
const RecommendedBadge = ({ className }) => {
    const { RecommendedBadge: css } = useTheme('Entities').FareGroupV2;
    const { t } = useTranslation('RecommendedBadge');
    return (React.createElement(Tooltip, { title: t('Best choice') },
        React.createElement("div", { className: cn(css.root, className) },
            React.createElement(CdnIcon, { className: css.icon, icon: "Info/Recommended" }))));
};
export default RecommendedBadge;
